var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeriodical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 12.7 12.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#edf2f7",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.264583
    },
    d: "M.012.028H12.73v12.689H.012z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a5568",
      fillOpacity: 1,
      strokeWidth: 0.644039
    },
    d: "M5.033 5.201V7.314h.29a2.074 2.132 0 0 1 1.716 2.102 2.074 2.132 0 0 1-.004.096h.026v30.69a2.074 2.155 0 0 1-1.49 1.92h-.51v2.11h15.681v-2.11h-.78a2.074 2.155 0 0 1-1.15-1.929 2.074 2.155 0 0 1 .016-.24h-.017V8.943a2.074 2.132 0 0 1 1.238-1.629h.762V5.201H5.033zm8.524 2.201a1.917 1.97 0 0 1 1.918 1.97 1.917 1.97 0 0 1-.004.134v.006h.027v30.703a1.917 1.991 0 0 1-1.914 1.87 1.917 1.991 0 0 1-1.908-1.82V8.997a1.917 1.97 0 0 1 1.88-1.594z",
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#edf2f7",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.299047
    },
    cx: 6.406,
    cy: 4.368,
    r: 3.203
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      fill: "#4a5568",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.262002
    },
    cx: 6.406,
    cy: 4.368,
    r: 2.806
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriodical);
export default __webpack_public_path__ + "static/media/periodical.9f7bc3eb35214ccf07a5dbfd7cee4c43.svg";
export { ForwardRef as ReactComponent };